import type { AuthTokens } from './tokens';

/**
 * Client-side auth session lifecycle.
 * OFFLINE means tokens may still be valid but the API is temporarily unreachable.
 */
export enum AuthStatus {
  UNKNOWN = 'unknown',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  OFFLINE = 'offline',
}

/**
 * Derives auth status from persisted tokens + user after rehydration.
 * Does not emit OFFLINE — that is a runtime-only transient state.
 */
export function deriveAuthStatus(
  tokens?: AuthTokens,
  user?: unknown,
): AuthStatus {
  if (tokens?.accessToken && user) {
    return AuthStatus.AUTHENTICATED;
  }
  if (tokens?.accessToken || tokens?.refreshToken) {
    return AuthStatus.UNKNOWN;
  }
  return AuthStatus.UNAUTHENTICATED;
}
